import { Outlet } from 'react-router-dom'
import Header from './Header'

export default function Layout() {
  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <main className="mt-12">
        <Outlet />
      </main>
    </div>
  )
}
